module.exports = __webpack_public_path__ + "img/position_pro_img4.561ffa09.png";